export enum HubAccountType {
  EZLO_HUB = 'ezlo_hub',
  EZLO_WIFI_HUB = 'ezlo_wifi_hub',
  PEPLINK_HUB = 'peplink_hub',
  ADC_HUB = 'adc_hub',
  SMART_LOCK = 'smart_lock',
  SCHLAGE = 'schlage',
  SCHLAGE_STAGING = 'schlage_staging',
}

export const HUB_ACCOUNT_TYPE = [
  {
    value: HubAccountType.EZLO_HUB,
    label: 'Ezlo Hub',
  },
  {
    value: HubAccountType.EZLO_WIFI_HUB,
    label: 'Ezlo Wifi Hub',
  },
  {
    value: HubAccountType.PEPLINK_HUB,
    label: 'Peplink Hub',
  },
  {
    value: HubAccountType.ADC_HUB,
    label: 'ADC Hub',
  },
  {
    value: HubAccountType.SMART_LOCK,
    label: 'Smart Lock',
  },
  {
    value: HubAccountType.SCHLAGE,
    label: 'Schlage',
  },
  {
    value: HubAccountType.SCHLAGE_STAGING,
    label: 'Schlage (Staging)',
  },
];

